export const SERVICES_TAGS: { [key: string]: string } = {
  CREATE_ASSETS: 'CREATE_ASSETS',
  GET_ACCOUNTS: 'GET_ACCOUNTS',
  CREATE_CUSTOMER: 'CREATE_CUSTOMER',
  GET_USER: 'GET_USER',
  GET_USERS: 'GET_USERS',
  UPDATE_PROMOTER: 'UPDATE_PROMOTER',
  PROPERTY_FULL_INFO: 'PROPERTY_FULL_INFO',
  PROPERTY_DETAIL: 'PROPERTY_DETAIL',
  SET_PERMISSION: 'SET_PERMISSION',
  GET_USERS_EVENT: 'GET_USERS_EVENT',
  GET_SALES_CHANNELS: 'GET_SALES_CHANNELS',
  PROPERTIES: 'PROPERTIES',
  WATCHED_PROPERTIES: 'WatchedProperties',
  CONTACTS: 'Contacts',
  ADMIN_AGENCIES: 'AdminAgencies',
};
